<style>

input[type="text"], input[type="password"], input[type="email"], input[type="number"], input[type="date"], textarea, select, .text-field {
  font-family: SenRegular;
  font-size: 20px;
  background-color: inherit;
  border: 0;
  border-bottom: 1px gray solid;
  height: 45px;
  border-radius: 0;
  width: 100%;
	padding: 7px 0 6px 0;
	box-sizing: border-box;
  outline: none;
  color: white;
}
input[type="text"].dark{
  color: black;
  border: 1px white solid;
  /* border-radius: 45px; */
  background-color: rgba(255,255,255,0.6);
}
input[type="text"].dark::placeholder{
  color: #555;
}
input[type="text"].text-no-line, input[type="password"].text-no-line, input[type="email"].text-no-line, input[type="number"].text-no-line, input[type="date"].text-no-line, textarea.text-no-line, select.text-no-line{
  border-bottom: none;
}

.label{
  margin: 10px 0;
}

</style>

<div class="label">Address<span class="required"> *</span></div>
<div><input type="text" bind:value="{item.address}" placeholder="address" on:keyup="{ () => dispatch('changed') }"></div>

<!-- <div class="label">Address 2</div> -->
<!-- <div><input type="text" bind:value="{item.address2}" placeholder="address 2" on:keyup="{ () => dispatch('changed') }"></div> -->

<!-- <div class="label">City<span class="required"> *</span></div> -->
<div><input type="text" bind:value="{item.city}" placeholder="city" on:keyup="{ () => dispatch('changed') }"></div>

<!-- <div class="label">State<span class="required"> *</span></div> -->
<div><input type="text" bind:value="{item.state}" placeholder="state" on:keyup="{ () => dispatch('changed') }"></div>

<!-- <div class="label">Zip<span class="required"> *</span></div> -->
<div><input type="text" bind:value="{item.zip}" placeholder="zip" on:keyup="{ () => dispatch('changed') }"></div>


<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

export let item = {};

</script>